import { render, staticRenderFns } from "./PairValue.vue?vue&type=template&id=0a0840a8&scoped=true&"
import script from "./PairValue.vue?vue&type=script&lang=js&"
export * from "./PairValue.vue?vue&type=script&lang=js&"
import style0 from "./PairValue.vue?vue&type=style&index=0&id=0a0840a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0840a8",
  null
  
)

export default component.exports